import React from "react";
import Header from "../header/Header";
import * as S from "./styles";

const GameOver = ({
  score,
  level,
  wave,
  bestCombo,
  wpm,
  accuracy,
  newRecord,
  onRestart,
  onMenu,
}) => {
  const highScore = parseInt(
    (typeof window !== "undefined" && localStorage.getItem(`writé:highscore:${level}`)) || "0",
    10
  );

  return (
    <S.Wrapper>
      <Header />
      <S.Content>
        <S.Title>GAME OVER</S.Title>
        {newRecord ? <S.RecordBadge>NEW RECORD</S.RecordBadge> : null}
        <S.Stats>
          <S.StatRow $primary>
            <span>SCORE</span>
            <strong>{score}</strong>
          </S.StatRow>
          <S.StatGrid>
            <S.StatBox>
              <span>HIGH</span>
              <strong>{highScore}</strong>
            </S.StatBox>
            <S.StatBox>
              <span>BEST COMBO</span>
              <strong>{bestCombo ?? 0}</strong>
            </S.StatBox>
            <S.StatBox>
              <span>WPM</span>
              <strong>{wpm ?? 0}</strong>
            </S.StatBox>
            <S.StatBox>
              <span>ACCURACY</span>
              <strong>{accuracy ?? 0}%</strong>
            </S.StatBox>
            <S.StatBox>
              <span>WAVE</span>
              <strong>{wave ?? 1}</strong>
            </S.StatBox>
            <S.StatBox>
              <span>LEVEL</span>
              <strong>{(level || "").toUpperCase()}</strong>
            </S.StatBox>
          </S.StatGrid>
        </S.Stats>
        <S.Buttons>
          <S.PrimaryButton onClick={onRestart}>RETRY</S.PrimaryButton>
          <S.SecondaryButton onClick={onMenu}>MENU</S.SecondaryButton>
        </S.Buttons>
      </S.Content>
    </S.Wrapper>
  );
};

export default GameOver;
